import { createGlobalStyle } from 'styled-components';
import normalize from 'app/normalise.css';

import 'rc-slider/assets/index.css';

const GlobalStyle = createGlobalStyle`
  ${normalize}
  
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: inherit;
  }
  html {
    font-size: 16px;

    ${({ theme: { media } }) => {
      return `
        ${media.xl(
          ({ scaleForHighRes }) => `
            font-size: ${scaleForHighRes('16px')};
            `,
        )}
      `;
    }}

  }
  @font-face {
    font-family: 'Brutal';
    src: url('/fonts/BrutalType-Light.otf') format('opentype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Brutal';
    src: url('/fonts/BrutalType-Regular.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Brutal';
    src: url('/fonts/BrutalType-Medium.otf') format('opentype');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Brutal';
    src: url('/fonts/BrutalType-Bold.otf') format('opentype');
    font-weight: 700;
    font-style: normal;
  }
  body {
    box-sizing: border-box;
    font-family: 'Poppins', sans-serif;
    background: ${({ theme: { colors } }) => colors.black};
    color: ${({ theme: { colors } }) => colors.white};
  }
`;

export default GlobalStyle;
